import { Component, OnInit } from '@angular/core';
import {Tile} from '../../../modele/dummyModel';
import {DummydataService} from '../../../services/dummydata/dummydata.service';
import {TranslateService} from '@ngx-translate/core';
import {EndpointService} from "../../../services/endpoint/endpoint.service";
import {ScssThemeChangeService} from '../../../services/scss_theme_change/scss-theme-change.service'
import { ShowhideService } from '../../../services/showhide/showhide.service';
import {CookieService} from 'ngx-cookie-service';
import {TourService} from 'ngx-tour-md-menu';
import {UserService} from "../../../services/user.service";
import {User, Owner} from '../../../modele/user/userModel';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    tilesaboutwhooosh: Tile[] = [];
    footer_visible:boolean;
    whoooshie_visible:boolean;
    isUserLoggedIn: boolean;
    getCurrentUserLiveRequest: User = new User();

    constructor(
        private dummydata: DummydataService,
        private translate: TranslateService,
        private endpointSrv: EndpointService,
        private themeChange: ScssThemeChangeService,
        private nav: ShowhideService,
        private cookieService: CookieService,
        private tourService: TourService,
        private userService: UserService,



    ) {
        this.footer_visible = true;
        this.nav.getFooterShowEmitter().subscribe(footershow=>{
            this.footer_visible = footershow
        })
        this.nav.getWhoooshieShowEmitter().subscribe(whoooshieshow=>{
            this.whoooshie_visible = whoooshieshow
        })
        this.userService.getUserSubject().subscribe(user => {
            this.getCurrentUserLiveRequest = user;
            this.isUserLoggedIn = true;
        });
        this.gettileaboutwhooosh();
    }
    ngOnInit(): void {


    }
    startToutByClickOnWhoooshie(){
        this.tourService.start();
    }
    gettileaboutwhooosh(): void {
        this.tilesaboutwhooosh = this.dummydata.getTilesAboutWhooosh();
    }
    switchLanguage(language: string) {
        this.translate.use(language);
        this.cookieService.set("whooosh_language", language);
    }
    switchTheme(appId: string) {
        this.themeChange.switchTheme(appId);
    }

}
